// deliveryRouteSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchRoutes = createAsyncThunk('deliveryRoute/fetchAll', async () => {
  const res = await axios.get('https//api.monkeybox.ai/api/routes');
  return res.data;
});

export const createRoute = createAsyncThunk('deliveryRoute/create', async (formData, { rejectWithValue }) => {
  try {
    const res = await axios.post('https//api.monkeybox.ai/api/routes', formData);
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response.data);
  }
});

export const updateRoute = createAsyncThunk('deliveryRoute/update', async ({ id, formData }, { rejectWithValue }) => {
  try {
    const res = await axios.patch(`https//api.monkeybox.ai/api/routes/${id}`, formData);
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response.data);
  }
});

const deliveryRouteSlice = createSlice({
  name: 'deliveryRoute',
  initialState: {
    routes: [],
    isLoading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetRouteState(state) {
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoutes.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchRoutes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.routes = action.payload;
      })
      .addCase(fetchRoutes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Failed to fetch routes';
      })
      .addCase(createRoute.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createRoute.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.routes.unshift(action.payload);
      })
      .addCase(createRoute.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Failed to create route';
      })
      .addCase(updateRoute.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateRoute.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.routes = state.routes.map((route) =>
          route.id === action.payload.id ? action.payload : route
        );
      })
      .addCase(updateRoute.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Failed to update route';
      });
  },
});

export const { resetRouteState } = deliveryRouteSlice.actions;
export default deliveryRouteSlice.reducer;
